import { render } from "./FDStatistics.vue?vue&type=template&id=0ecf26e6"
import script from "./FDStatistics.vue?vue&type=script&lang=js"
export * from "./FDStatistics.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__